var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"notFound",staticClass:"notFound"},[_c('div',{staticClass:"marginTopDiv"}),_vm._v(" "),_c('div',{staticClass:"notImg"}),_vm._v(" "),_c('div',{staticClass:"notExplain"},[_vm._v("找不到页面了:(")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":_vm.back}},[_vm._v("返回")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6cb5ea00","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/notFound/notFound.vue
// module id = null
// module chunks = 